import React from "react";
import CustomMultipleResourcePage from "../components/CustomMultipleResourcePage";
import { Container } from "@amzn/awsui-components-react";

const JournalEntryPage = ({selectedCPView, viewAccess, addOrEditAccess, resetHref}) => (
  <Container>
    <CustomMultipleResourcePage
      pageType="JOURNAL ENTRY"
      tabType="LIST"
      owner={selectedCPView}
      viewAccess={viewAccess}
      addOrEditAccess={addOrEditAccess}
      resetHref={resetHref}
    />
  </Container>
);

export default JournalEntryPage;
